import { capitalDesignTokens, createTypedSxStyles } from "@opengov/capital-mui-theme";

const { semanticColors } = capitalDesignTokens;

export const styles = createTypedSxStyles({
  container: {
    display: "flex",
    minHeight: "100%",
    flexDirection: "column",
    backgroundColor: semanticColors.background.primary,
  },
  publicationView: {
    display: "flex",
    flexDirection: "column",
    flex: 1,
  },
  contentWrapper: {
    display: "flex",
    flexDirection: "row",
    flex: 1,
  },
  publicationStoriesContainer: {
    display: "flex",
    flex: 1,
    flexDirection: "column",
    paddingTop: "24px",
    overflow: "hidden",
  },
  publicationStoriesContainerWithPadding: {
    display: "flex",
    flex: 1,
    flexDirection: "column",
    paddingTop: "24px",
    overflow: "hidden",
    paddingLeft: "24px",
  },
  publicationStoriesContent: {
    display: "flex",
    flex: 1,
    flexDirection: "column",
    width: "100%",
    padding: "8px 24px 0 0",
  },
  publicationExportBanner: {
    margin: "24px 24px 0 24px",
  },
  banner: {
    marginRight: "24px",
  },
  centered: {
    textAlign: "center",
    margin: "auto",
  },
  hide: {
    display: "none",
  },
  folderContentHeader: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-between",
    marginRight: "24px",
    marginBottom: "24px",
    overflow: "hidden",
  },
  hideOverflow: {
    overflow: "hidden",
  },
  folderTitle: {
    display: "flex",
    alignItems: "center",
    overflow: "hidden",
    marginRight: "24px",
  },
  buttonContainer: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center",
    columnGap: "8px",
  },
  sectionButtonsContainer: {
    display: "flex",
    flexDirection: "row",
    gap: "8px",
    alignItems: "center",
    flex: 1,
    justifyContent: "flex-end",
  },
  exportPdfInlineMessagesContainer: {
    flex: 2,
  },
  controlBarContainer: {
    paddingRight: "24px",
  },
  exportPdfInProgress: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    fontSize: "12px",
    marginRight: "8px",
    gap: "8px",
  },
  exportPdfSuccess: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
  },
  exportPdfCheckIcon: {
    color: semanticColors.foreground.successLarge,
    marginRight: "4px",
    fontSize: "16px",
  },
  exportPublicationPdfInProgress: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    gap: "8px",
    marginTop: "12px",
  },
  exportPublicationPdfSuccess: {
    marginTop: "12px",
  },
  exportPublicationPdfDownload: {
    marginTop: "8px",
  },
  sectionHeaderText: {
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
    overflow: "hidden",
  },
  editButton: {
    marginLeft: "8px",
    verticalAlign: "super",
    color: semanticColors.foreground.action,
  },
  deleteSectionMenuItem: {
    color: semanticColors.foreground.errorLarge,
  },
});
